<template>
    <div>
        <div class="line"></div>
    </div>
</template>
<script>
export default {
    name: 'theButtonLine',
}
</script>
<style lang="scss" scoped>
.line {
    height: 10px;
    width: 100%;
    background-color: #c40017;
    position: fixed;
    bottom: 0;
}
</style>
